import script from "./CardsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./CardsTable.vue?vue&type=script&setup=true&lang=js"

import "./CardsTable.vue?vue&type=style&index=0&id=1e485f1c&lang=scss"

const __exports__ = script;

export default __exports__